export class GlobalRouteConfiguration {
  constructor(private $stateProvider: ng.ui.IStateProvider) {}

  state() {
    this.$stateProvider
      .state('landing', {
        url: '/landing/',
        params: {
          user_name: undefined
        },
        views: {
          '@': {
            template: '<anonymous-landing></anonymous-landing>'
          },
          'left@landing': {
            templateUrl: 'lib/user_app/views/login/login.html',
            controller: 'ngLoginController',
            controllerAs: '$ctrl'
          }
        },
        data: {
          viewTitle: 'Transfer Portal Landing Page'
        }
      })
      .state('landing.terms_of_use', {
        url: 'terms_of_use/',
        views: {
          'modal@landing': {
            templateUrl: 'lib/global/modals/terms_of_use/terms_of_use.html',
            controller: 'ngLicenseAgreementModalController',
            controllerAs: '$ctrl'
          }
        },
        data: {
          viewTitle: 'Terms of Use'
        }
      })
      .state('startup', {
        url: '/',
        templateUrl: 'lib/global/views/startup/startup.html',
        controller: 'ngStartupController'
      })
      .state('oops', {
        url: '/oops/',
        templateUrl: 'lib/global/views/oops/oops.html',
        controller: 'ngOopsController',
        controllerAs: '$ctrl',
        data: {
          viewTitle: 'Oops'
        },
        params: {
          explanation: ''
        }
      })
      .state('my.modal.contact_counselor', {
        url: 'contact_counselor/',
        views: {
          'modal@my': {
            templateUrl: 'lib/global/modals/contact_counselor/contact_counselor.html',
            controller: 'ngContactCounselorModalController',
            controllerAs: '$ctrl'
          }
        },
        data: {
          viewTitle: 'Contact Counselor'
        }
      })
      .state('my.modal.terms_of_use', {
        url: 'terms_of_use/',
        views: {
          'modal@my': {
            templateUrl: 'lib/global/modals/terms_of_use/terms_of_use.html',
            controller: 'ngLicenseAgreementModalController',
            controllerAs: '$ctrl'
          }
        },
        data: {
          viewTitle: 'Terms of Use'
        }
      });
  }

  $get() {
    return {};
  }
}

angular.module('capability-ng-global').provider('ngGlobalRouteConfiguration', GlobalRouteConfiguration);



// WEBPACK FOOTER //
// ./app/lib/global/configuration/route_configuration.ts